import React from "react";

// Reusable full-screen loading state.
// Uses the brand's gold spinner on the dark background.
export const GlobalLoading = ({ label = "Cargando..." }) => (
  <div
    className="min-h-[60vh] flex items-center justify-center"
    role="status"
    aria-live="polite"
    data-testid="global-loading"
  >
    <div className="flex flex-col items-center gap-4">
      <div className="w-10 h-10 rounded-full border-2 border-[#C8A24A]/25 border-t-[#C8A24A] animate-spin" />
      {label && <p className="text-sm text-[#C8A24A]/70">{label}</p>}
    </div>
  </div>
);

// Inline variant for use inside a card / section.
export const InlineLoading = ({ label = "Cargando..." }) => (
  <div className="py-8 flex items-center justify-center gap-3" role="status" aria-live="polite">
    <div className="w-5 h-5 rounded-full border-2 border-[#C8A24A]/25 border-t-[#C8A24A] animate-spin" />
    <p className="text-xs text-[#C8A24A]/70">{label}</p>
  </div>
);
